module.exports = __webpack_public_path__ + "static/media/sign.0355754e.png";